var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3fafe;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.98,60.04c-12.92-.02-24.96-8.9-28.75-21.32C-2.53,26.34,2.57,12.62,13.06,5.24c10.13-7.13,23.75-6.95,33.89-.02,10.38,7.09,15.25,20.12,12.1,32.28-1.52,5.87-4.75,11.11-9.29,15.12-2.56,2.27-5.44,4.18-8.64,5.41-3.62,1.4-7.3,1.74-11.14,2.01Zm.09-57.49c-15.19-.05-27.82,12.32-27.64,27.79.17,14.34,12.15,27.98,28.93,27.11,14.19-.73,26.14-11.54,26.22-27.39.07-14.97-11.96-27.56-27.52-27.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.2,36.4c-.25-.23-.47-.41-.67-.61q-1.12-1.1-.04-2.17c4.03-4.03,8.06-8.06,12.08-12.11.39-.39.63-.41,1.04,0,4.18,4.21,8.37,8.4,12.57,12.58.4.4.44.68-.01,1.04-.3.24-.58.53-.82.83-.31.38-.52.36-.87,0-2.63-2.67-5.29-5.33-7.94-7.99-1.01-1.02-2.05-2.01-3.04-3.05-.34-.36-.55-.28-.85.03-3.67,3.7-7.35,7.39-11.03,11.08-.12.12-.27.22-.44.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkers);
export default __webpack_public_path__ + "static/media/Markers.3538b1d203426c1f28cb50b182148078.svg";
export { ForwardRef as ReactComponent };